import React, { useCallback, useEffect } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {jwtDecode, JwtPayload } from 'jwt-decode'
import { Box, Flex } from '@chakra-ui/react'

import RegisterUser from 'components/subscription/RegisterSuscription/registerUser'
import LoadingScreen from 'components/common/LoadingScreen/LoadingScreen'
import { validateTokenValidate } from 'services/api'
import { IValidateToken, IReturnValidateToken } from 'services/IApi.d'
import Form from 'providers/FormProvider'
import { useSubscriberContext } from 'providers/SubscriberProvider'

import { setToken } from 'utils/authentication'
import { isSuccessStatus } from 'utils/functions/validations'
import { defaultUserFields } from '../RegisterSuscription/subscriptionTypes'
import { IAditionalParams } from '../IRecoveryUser.d'

function RecoveryChangeUser() {
  const { setSubscriberData } = useSubscriberContext()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = React.useState<boolean>(true)
  const code: string = searchParams.get('code')
  const initValues = {
    input: '',
    inputConfirmation: '',
  }

  const handleReCaptchaVerify = useCallback(async (action: string) => {
    if (!executeRecaptcha) {
      console.info('Execute recaptcha not yet available')
      return ''
    }
    const token: string = await executeRecaptcha(action)
    return token
  }, [executeRecaptcha])

  const loadValidateToken = async (validateTokenData: IValidateToken) => {
    try {
      const recaptchaToken: string = await handleReCaptchaVerify('recovery_password')
      const response: IReturnValidateToken = await validateTokenValidate(validateTokenData, { headers: { 'x-recaptcha-token': recaptchaToken } })
      if (!isSuccessStatus(response.status)) {
        navigate('/suscripcion/error-recuperar', { state: { pageBefore: 'recoveryUser500' } })
        return null
      }
      if (!response?.data?.esTokenValido) {
        navigate('/suscripcion/error-recuperar', { state: { pageBefore: 'recoveryTokenInvalid' } })
        return null
      }
      return response
    } catch (e) {
      throw new Error(`Error: ${e}`)
    }
  }

  useEffect(() => {
    if (!executeRecaptcha) return

    const decoded: any = jwtDecode<JwtPayload>(code)
    const { canal, parametrosAdicionales, fechaHoraSolicitud, requestId } = decoded
    const splitData = parametrosAdicionales.split('&')
    const params: IAditionalParams = {}
    splitData.forEach(item => {
      const spliItem = item.split('=')
      // eslint-disable-next-line prefer-destructuring
      params[spliItem[0]] = spliItem[1]
    })
    setSubscriberData(() => ({ documento: requestId, pais: params.pais, nacionalidad: params.nacionalidad, email: params.email }))
    if (loading) {
      loadValidateToken({
        canal,
        fechaHoraToken: fechaHoraSolicitud,
        requestId,
        token: code,
      }).then((response: IReturnValidateToken) => {
        if (response) {
          setLoading(false)
          setToken(response.data.token, response.data.tokenType)
        }
      })
    }
  }, [executeRecaptcha])

  return (
    <Flex>
      { loading ? (
        <LoadingScreen title='Estamos procesando tu información' description='Esto puede demorar unos instantes' fullpage />
      ) : (
        <Box flex='1' id='right-side' px='6' py='0'>
          <Form initialValues={initValues}>
            <RegisterUser type='user' displayName='usuario' innitialValues={defaultUserFields} recoveryUser />
          </Form>
        </Box>
      )}
    </Flex>
  )
}

export default RecoveryChangeUser
